import { ConnectionState } from "livekit-client";

export function hasActiveLiveKitConnection(state: ConnectionState | undefined | null): boolean {
  return (
    state === ConnectionState.Connected ||
    state === ConnectionState.Connecting ||
    state === ConnectionState.Reconnecting
  );
}
